var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('img',{attrs:{"id":"logo","src":require("@/assets/logo-full.png"),"alt":"43-Hotel"}}),_c('a',{staticClass:"text button",attrs:{"target":"_blank","href":"https://www.booking.com/hotel/th/43hotel.html"}},[_vm._v(" Book now on Booking.com! ")])])
}]

export { render, staticRenderFns }